import { addColumns } from '@nozbe/watermelondb/Schema/migrations'

export default {
  toVersion: 15,
  steps: [
    addColumns({
      table: 'chats',
      columns: [{ name: 'tags', type: 'string', isOptional: true }]
    })
  ]
}
